import { useState, useCallback, memo } from 'react';
import { pluralize } from '@/utils';

import { MultipleValuesTextArea } from '@/components/ui/multipleValuesTextArea/multipleValuesTextArea';
import { DialogClose, DialogFooter } from '@/shadcn/dialog';
import { Button } from '@/shadcn/button';
import { TestId } from '@/types/testId';
import { newEmailValidation } from './addUsers.utils';

type Props = {
  submit: (emails: string[]) => void;
};

// Modal content to add a set of users from their emails
export const AddUsers = memo(({ submit }: Props) => {
  // state for handling list of emails
  const [emails, setEmails] = useState<string[]>([]);

  // callback to report if a new string value can be added to the list of emails
  const validateNewEmail = useCallback(
    (str: string) => newEmailValidation(str, emails),
    [emails]
  );

  return (
    <>
      <MultipleValuesTextArea
        values={emails}
        updateValues={setEmails}
        errorFn={validateNewEmail}
        toLowerCase
        splitKeys={[' ', 'Enter', 'Tab']}
      />
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="outline" data-testid={TestId.AddUsers.CancelButton}>
            cancel
          </Button>
        </DialogClose>

        <Button
          onClick={() => submit(emails)}
          disabled={!emails.length}
          data-testid={TestId.AddUsers.SubmitButton}
        >
          {emails.length
            ? `Add ${pluralize(emails.length, 'participant', false, true)}`
            : 'Add participant'}
        </Button>
      </DialogFooter>
    </>
  );
});
